import moment from 'moment/moment';

export default function (app) {
  app.controller('klCustomerCenterSubscriptionUsageCtrl', [
    '$state',
    '$http',
    '$timeout',
    'klAccountService',
    function ($state, $timeout, $http, AccountService) {
      const usageCtrl = this;
      usageCtrl.isLoadingTable = false;
      usageCtrl.init = function (subscription) {
        usageCtrl.usage(subscription);
      };
      usageCtrl.updateTable = function (subscription) {
        usageCtrl.isLoadingTable = true;
        const usersTimeSpan = usageCtrl.timeSpan.val > 30 ? 30 : usageCtrl.timeSpan.val;
        AccountService.getLicenseUsageTable(subscription.License_Id__c, usersTimeSpan)
          .then((response) => {
            if (!response[0] || !response[0].userName) {
              response = [
                {
                  userName: 'No Users Active',
                  cad: '',
                  machineName: '',
                  minutesUsed: '',
                  durationInMinutes: '',
                },
              ];
            }
            response.forEach(function (element, index) {
              if (!element.time && element.durationInMinutes) {
                const duration = moment.duration(element.durationInMinutes, 'minutes');
                response[index].time = `${
                  duration.hours() + duration.days() * 24
                }h:${duration.minutes()}m`;
              }
            });
            usageCtrl.usageTableData = response;
            usageCtrl.csvExportData = response;
          })
          .then(() => AccountService.getUsageActiveUsers(subscription.License_Id__c))
          .then((response) => {
            if (!response[0] || !response[0].user) {
              response = [
                {
                  user: 'No Users Active',
                  autodesk: '',
                  machine: '',
                },
              ];
            }
            usageCtrl.usageActiveUsers = response;
          })
          .then(function () {
            usageCtrl.isLoadingTable = false;
          });
      };
      usageCtrl.updateChart = function (subscription) {
        var stepSize = 1;
        var stepUnit = 'hour';
        var filterAmPm = '';
        var maximumUsage = 0;
        usageCtrl.isLoadingPopUp = true;
        usageCtrl.updateTable(subscription);
        AccountService.getLicenseUsageChart(subscription.License_Id__c, usageCtrl.timeSpan.val)
          .then((response) => {
            if (!response[0]) {
              response = [];
              response[0] = {
                time: moment().subtract(1, 'day').valueOf(),
                used: 0,
              };
              response[1] = {
                time: moment().valueOf(),
                used: 0,
              };
            }
            response.forEach(function (element, index) {
              response[index].x = new Date(element.time);
              response[index].y = element.used;
              if (maximumUsage < parseInt(element.used)) {
                maximumUsage = parseInt(element.used);
              }
            });
            if (usageCtrl.timeSpan.val == '7') {
              stepSize = 12;
              filterAmPm = 'a';
            }
            if (parseInt(usageCtrl.timeSpan.val) > 7) {
              stepUnit = 'day';
            }
            if (parseInt(usageCtrl.timeSpan.val) > 30) {
              stepUnit = 'week';
            }
            var filteredResponse = [];
            if (parseInt(usageCtrl.timeSpan.val) > 1) {
              var currentMax = response[0];
              var currentDate = response[0].x;

              response.forEach((e) => {
                if (
                  moment(currentDate).format('MMM Do YY' + filterAmPm) ==
                    moment(e.x).format('MMM Do YY' + filterAmPm) &&
                  parseInt(e.y) > parseInt(currentMax.y)
                ) {
                  currentMax = e;
                }
                if (
                  moment(currentDate).format('MMM Do YY' + filterAmPm) !=
                  moment(e.x).format('MMM Do YY' + filterAmPm)
                ) {
                  filteredResponse.push(currentMax);
                  currentDate = e.x;
                  currentMax = e;
                }
              });
              filteredResponse.push(currentMax);
              response = filteredResponse;
            }
            usageCtrl.chartData = [response];
            usageCtrl.chartDatasetOverride = [
              {
                label: 'Licenses in use',
                borderWidth: 0,
                pointRadius: 0,
                pointBorderWidth: 0,
                fall: false,
              },
            ];
            usageCtrl.chartOptions = {
              responsive: false,
              elements: {
                line: {
                  tension: 0,
                },
              },
              scales: {
                xAxes: [
                  {
                    type: 'time',
                    time: {
                      unit: stepUnit,
                      unitStepSize: stepSize,
                      autoSkip: false,
                      displayFormats: {
                        day: 'MMM D',
                        hour: 'MMM D ha',
                      },
                      min: new Date(response[0].time),
                      max: new Date(
                        2 * response[response.length - 1].time - response[response.length - 2].time,
                      ),
                    },
                    scaleLabel: { display: true },
                  },
                ],
                yAxes: [
                  {
                    type: 'linear',
                    ticks: {
                      min: 0,
                      max: maximumUsage,
                      stepSize: maximumUsage > 10 ? 5 : 1,
                    },
                  },
                ],
              },
            };
          })
          .then(function () {
            usageCtrl.isLoadingPopUp = false;
          });
      };
      usageCtrl.usage = function (subscription) {
        if (!subscription) {
          return;
        }
        usageCtrl.timeSpanOptions = [
          {
            name: 'Last 180 Days',
            val: 180,
          },
          {
            name: 'Last 30 Days',
            val: 30,
          },
          {
            name: 'Last 7 Days',
            val: 7,
          },
          {
            name: 'Last 24 Hours',
            val: 1,
          },
        ];
        usageCtrl.csvExportData = [];
        usageCtrl.sortType = 'durationInMinutes';
        usageCtrl.sortTypeActive = 'user';
        usageCtrl.sortReverse = true;
        usageCtrl.sortReverseActive = false;
        usageCtrl.usageSub = subscription;
        usageCtrl.timeSpan = usageCtrl.timeSpanOptions[0];
        usageCtrl.updateChart(usageCtrl.usageSub);
      };

      usageCtrl.closeUsage = function () {
        $state.go('subscription');
      };

      usageCtrl.loaded = function () {
        const wrapper = document.getElementById('usagechart-canvas-wrapper');
        const canvas = document.getElementById('usagechart-canvas');
        canvas.width = wrapper.clientWidth;
      };
    },
  ]);
}
